import { useDispatch, useSelector } from 'react-redux';

import { addToBasket, clearBasket} from '../support/store/BasketReducer';

export default function useBasket() {
  const dispatch = useDispatch();
  const spaceId = useSelector((state) => state.BasketReducer.producerId);
  const basketItems = useSelector((state) => state.BasketReducer.offers);

  const addItemToBasket = async (offer, amount) => {
    if (amount < 1 || amount === '0') {
      throw new Error('Adicione a quantidade desejada.');
    }

    if (amount > offer.availableStock && offer.type !== 'scheduled_delivery') {
      throw new Error(`A quantidade desejada não está disponível. Há ${offer.availableStock} ${offer.availableStock > 1 ? 'disponíveis' : 'disponível'}`);
    }

    if (spaceId !== ''
      && spaceId !== offer.producerId) {
      if (window.confirm('Sua cesta possui itens de outro espaço, no entanto, só é possível fazer pedidos a um espaço por vez. Deseja prosseguir?')) {
        dispatch(clearBasket());
      } else return;
    }

    dispatch(addToBasket({ id: offer.id, amount: Number(amount), producerId: offer.producerId }));
  };

  const clear = () => dispatch(clearBasket());

  return {
    sharedStates: {
      spaceId,
      basketItems,
    },
    commands: {
      addItemToBasket,
      clear
    },
  };
}
